import { apiGateway } from "../context";
import type { PatientBaseAttributes } from "../interfaces";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

export interface CreatePatientPayload {
  doctorCode: string;
  patient: PatientBaseAttributes;
}

export const createPatientFn = (patientPayload: CreatePatientPayload) => {
  return apiGateway<{
    linkId: string;
    doctorUuid: string;
    patientUuid: string;
  }>({
    method: "POST",
    url: "/clinical-history/doctor-patient-links",
    data: patientPayload,
  });
};

export const useCreatePatient = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: createPatientFn,
    onError(error) {
      console.log("Error creating patient: ", error);
      navigate("/app/solicitudes");
    },
  });
};
